module.exports = __webpack_public_path__ + "img/ZA.d57bbafc.png";